import { getActivePinia } from 'pinia';
import types from 'dashboard/store/mutation-types';

/** Agents API uses `thumbnail`; Web Order UI historically used `avatarUrl`. */
export const agentAvatarUrl = agent =>
  String(
    agent?.avatarUrl || agent?.thumbnail || agent?.avatar_url || ''
  ).trim();

/**
 * Patch Vuex agent/assignee thumbnails and Pinia Web Order avatars together.
 * Merges onto the matching agents record — never replace via EDIT_AGENT.
 */
export const syncAgentAvatarEverywhere = (
  { commit, rootGetters },
  agent,
  { updateCurrentUser = true } = {}
) => {
  const id = agent?.id;
  if (id == null) return;

  const thumbnail = agentAvatarUrl(agent);
  commit(
    `agents/${types.UPDATE_AGENT_ATTRIBUTES}`,
    { id, thumbnail, avatar_url: thumbnail },
    { root: true }
  );
  commit(types.UPDATE_ASSIGNEE_AVATAR, { id, thumbnail }, { root: true });
  commit(
    'inboxAssignableAgents/UPDATE_ASSIGNABLE_AGENT_AVATAR',
    { id, thumbnail },
    { root: true }
  );

  const currentUser = rootGetters?.getCurrentUser;
  if (updateCurrentUser && currentUser?.id === id) {
    commit(
      types.SET_CURRENT_USER,
      { ...currentUser, avatar_url: thumbnail },
      { root: true }
    );
  }

  if (!getActivePinia()) return;
  import('dashboard/stores/webOrder')
    .then(({ useWebOrderStore }) => {
      useWebOrderStore().syncAgentAvatar({
        id,
        thumbnail,
        avatarUrl: thumbnail,
        avatar_url: thumbnail,
      });
    })
    .catch(() => {});
};

export const resolveAgentAvatar = (agent, catalogs = []) => {
  const direct = agentAvatarUrl(agent);
  if (direct) return direct;

  const id = Number(agent?.id);
  if (!id) return '';

  return catalogs.reduce((found, list) => {
    if (found) return found;
    const match = (list || []).find(item => Number(item.id) === id);
    return agentAvatarUrl(match);
  }, '');
};
